import { StageReminderDTO } from 'data/from-data/create-task-form.data';
import { StageReminderValue } from '../types/formFields';

/**
 * Build the stageReminder payload sent to the API.
 * - A stage reminder is job-scoped, so returns null when there is no jobId.
 * - triggerType 'none' returns null (clears any existing reminder on update,
 *   ignored on create).
 * - 'any_stage_change' never carries stage ids.
 * - 'specific_stages' carries the selected stage ids.
 */
export const buildStageReminderPayload = (
  jobId: string | undefined | null,
  stageReminder: StageReminderValue | undefined
): StageReminderDTO | null => {
  if (!jobId) return null;
  if (!stageReminder || stageReminder.triggerType === 'none') return null;
  if (stageReminder.triggerType === 'any_stage_change') {
    return { triggerType: 'any_stage_change', stageIds: [] };
  }
  return {
    triggerType: 'specific_stages',
    stageIds: stageReminder.stageIds || []
  };
};

/** Map an existing task's reminder (or absence of one) to a form value. */
export const stageReminderToFormValue = (
  reminder:
    | {
        triggerType: 'any_stage_change' | 'specific_stages';
        stageIds: string[];
      }
    | null
    | undefined
): StageReminderValue => {
  if (!reminder) return { triggerType: 'none', stageIds: [] };
  return {
    triggerType: reminder.triggerType,
    stageIds: reminder.stageIds || []
  };
};
